import { Controller } from "@hotwired/stimulus";
import { NestedFormRenumber } from "../shared/nested_form_renumber";
import { FormClearable } from "../shared/form_clearable";
import { NestedFormMaxNumber } from "../shared/nested_form_max_number";

// Connects to data-controller="resumin--form-addition"
export default class extends Controller {
  static targets = ["container", "template"];
  // valuesには定義していないが、以下の属性を要素に設定すると、コピーはしない。
  // data-resumin--form-addition-ignore-value=true
  static values = {
    removeClass: String, // 要素のクラスを削除する場合に指定
  };

  connect() {
    FormClearable(this);
    NestedFormRenumber(this);
    NestedFormMaxNumber(this);
  }

  add(e) {
    e.preventDefault();

    const newElement = this.templateTarget.cloneNode(true);
    this._clearElementValue(newElement);
    this._removeElement(newElement);
    this._removeClass(newElement);
    this.containerTarget.appendChild(newElement);
    return newElement;
  }

  _clearElementValue(element) {
    const elements = element.querySelectorAll("input, select, textarea");
    const ids = this.containerTarget.querySelectorAll(
      '[data-resumin--form-addition-target="id"]'
    );
    const index = this.maxNumberFromId(ids) + 1;

    elements.forEach((input) => {
      this.renumber(input, index);
      this.clearElement(input);
    });
  }

  _removeElement(element) {
    element
      .querySelectorAll("[data-resumin--form-addition-ignore-value='true']")
      .forEach((el) => el.remove());
  }

  _removeClass(element) {
    const classNames = this.removeClassValue;
    if (classNames) {
      classNames.split(" ").forEach((cls) => {
        element
          .querySelectorAll(`.${cls}`)
          .forEach((el) => el.classList.remove(cls));
      });
    }
  }
}
